<template>
  <b-modal
    ref="modal-tambah-bahan-packing"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-[32px]"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div v-if="!isSuccess">
      <h3 class="text-[#333333] text-[24px] font-semibold text-center mb-[24px]">
        Tambah Bahan Packing
      </h3>
      <ValidationObserver
        ref="observer"
        v-slot="{ handleSubmit }"
      >
        <form @submit.prevent="handleSubmit(handleTambahBahanPacking)">
          <div id="mtbp_form">
            <div class="mb-[24px]">
              <div
                v-if="!image"
              >
                <label
                  id="mtbp_form_image"
                  for="image"
                >Pilih File untuk Diupload</label>
                <div
                  id="image"
                  class="border-[#E2E2E2] grid justify-center border-[1px] p-[24px] rounded-lg bg-[#F4F4F4]"
                  @dragover.prevent="onDragOver"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onDrop"
                  @click="handleClickImage"
                >
                  <div class="justify-center flex mb-[12px]">
                    <b-img
                      height="48"
                      width="48"
                      src="https://storage.googleapis.com/komerce//document-upload-black.svg"
                    />
                  </div>
                  <div class="text-center">
                    <p class="mb-[4px] text-[16px] font-semibold text-[#333333]">
                      Klik atau drag file ke area ini untuk unggah
                    </p>
                    <p
                      class="text-[14px] font-normal mb-0 text-[#626262]"
                    >
                      Mendukung untuk unggahan tunggal
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else
              >
                <div class="relative w-fit pt-[12px] pr-[12px] mb-[8px]">
                  <b-img
                    height="56"
                    width="56"
                    :src="imagePreview"
                  />
                  <button
                    class="absolute top-0 right-0 hover:bg-[#F4F4F4] rounded-full p-[1px] size-[26px] transition-all duration-300"
                    @click="handleRemoveImage"
                  >
                    <span class="k-close-circle text-[24px] text-[#828282]" />
                  </button>
                </div>
                <p class="mb-0">
                  {{ image.name }}
                </p>
              </div>
              <input
                ref="mtbp_image"
                type="file"
                name="mtbp_image"
                accept=".jpeg,.jpg,.png,.svg"
                hidden
                @change="handleFileUpload"
              >
              <div
                v-if="imageError"
                class="invalid-feedback !block"
              >
                {{ imageError }}
              </div>
            </div>
            <ValidationProvider
              v-slot="{ errors }"
              name="Nama Bahan Packing"
              rules="required|min:2|max:50"
            >
              <div class="mb-[24px]">
                <label
                  for="name"
                  class="mb-[8px]"
                >Bahan Packing</label>
                <b-input
                  v-model="name"
                  type="text"
                  name="name"
                  class="w-full"
                  placeholder="Nama bahan packing"
                  :class="{ 'is-invalid': errors.length > 0 }"
                />
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                >
                  {{ errors[0] }}
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="Satuan"
              rules="required"
            >
              <div class="mb-[24px]">
                <label
                  for="name"
                  class="mb-[8px]"
                >Pilih Satuan</label>
                <div class="position-relative">
                  <b-select
                    v-model="satuan"
                    name="satuan"
                    :options="satuanOptions"
                    class="w-full custom-select"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    placeholder="Pilih satuan"
                  />
                  <feather-icon
                    icon="ChevronDownIcon"
                    size="20"
                    class="position-absolute select-icon"
                  />
                </div>
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback d-block"
                >
                  {{ errors[0] }}
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="Harga"
              rules="required"
            >
              <div class="mb-[24px]">
                <label
                  for="name"
                  class="mb-[8px]"
                >Harga</label>
                <b-input
                  v-model="priceFormatted"
                  type="text"
                  name="price"
                  class="w-full"
                  placeholder="Rp 0"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @input="handlePriceInput"
                  @keypress="validateNumericOnly"
                />
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                >
                  {{ errors[0] }}
                </div>
              </div>
            </ValidationProvider>
            <div class="flex items-center justify-between gap-2">
              <b-button
                variant="outline-primary"
                class="grow w-full"
                @click="handleCloseModal"
              >
                Kembali
              </b-button>
              <b-button
                variant="primary"
                type="submit"
                class="grow w-full flex items-center justify-center gap-4"
                :disabled="isPending"
              >
                <b-spinner
                  v-if="isPending"
                  small
                />
                {{ isPending ? 'Memproses...' : 'Buat Bahan Packing' }}
              </b-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div
      v-else
      class="text-center gap-2 relative"
    >
      <button
        class="absolute top-0 right-0"
        @click="handleCloseModal"
      >
        <span class="k-close text-[38px] text-[#333]" />
      </button>
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="success"
        width="100"
        height="100"
        class="mx-auto"
      >
      <h3 class="text-[#333] text-[24px] font-semibold my-[20px]">
        Data Sedang Ditinjau
      </h3>
      <p class="text-[#626262] text-[14px] font-normal mb-0">
        Tim Operasional Kompack sedang memeriksa pengajuan bahan packing terbaru. Proses ini biasanya memakan waktu hingga 1x24 jam. Mohon ditunggu sebentar ya
      </p>
      <b-button
        variant="primary"
        class="w-full mt-[20px]"
        @click="handleKonfirmasi"
      >
        Konfirmasi
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { toastError } from '@/libs/toastification'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, min, max } from 'vee-validate/dist/rules'
import { allowedImageExtensions, allowedImageSize } from '../config'

extend('required', {
  ...required,
  message: '{_field_} harus diisi',
})

extend('min', {
  ...min,
  message: '{_field_} minimal {length} karakter',
})

extend('max', {
  ...max,
  message: '{_field_} maksimal {length} karakter',
})

export default {
  name: 'ModalTambahBahanPacking',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      image: null,
      imageError: null,
      imagePreview: null,
      name: null,
      price: null,
      priceFormatted: '',
      isSuccess: false,
      satuan: 1,
      isPending: false,
      priceInputTimeout: null,
    }
  },
  created() {
    this.satuanOptions = [
      { value: 1, text: 'Qty' },
      { value: 2, text: 'm²' },
    ]
  },
  beforeDestroy() {
    this.cleanupImagePreview()

    if (this.priceInputTimeout) {
      clearTimeout(this.priceInputTimeout)
      this.priceInputTimeout = null
    }
  },
  methods: {
    show() {
      this.isSuccess = false
      this.$refs['modal-tambah-bahan-packing'].show()
    },
    handleCloseModal() {
      this.$refs['modal-tambah-bahan-packing'].hide()
    },
    handleKonfirmasi() {
      this.$emit('confirmed')
      this.handleCloseModal()
    },
    onDragOver(event) {
      event.preventDefault()
      let target = event.target.style.border
      target = '2px dashed #000'
    },
    onDragLeave(event) {
      let target = event.target.style.border
      target = ''
    },
    cleanupImagePreview() {
      if (this.imagePreview) {
        URL.revokeObjectURL(this.imagePreview)
      }
    },
    /**
     * Check file metadata, the requirements are:
     * - Extension is allowed (jpeg, jpg, png, svg)
     * - Size is less than 1MB
     * @param {Object} payload - Payload
     */
    checkFileMetadata({
      extension,
      size,
      file,
    }) {
      if (!allowedImageExtensions.includes(extension)) {
        this.imageError = 'File tidak sesuai. Format File: JPEG, PNG, SVG'
        return
      }
      if (size >= allowedImageSize) {
        this.imageError = 'Ukuran file terlalu besar. Max: 1MB'
        return
      }

      this.cleanupImagePreview()

      this.imageError = null
      this.image = file
      this.imagePreview = URL.createObjectURL(file)
    },
    /**
     * Handle drop event so we can upload file
     * @param {Event} event - Event
     */
    onDrop(event) {
      event.preventDefault()
      const droppedFiles = event.dataTransfer.files[0]

      if (!droppedFiles) return

      const fileExtension = droppedFiles.name.split('.').pop().toLowerCase()
      const { size } = droppedFiles

      this.checkFileMetadata({
        extension: fileExtension,
        size,
        file: droppedFiles,
      })
    },
    /**
     * Handle click event on drop zone so we can upload file
     */
    handleClickImage() {
      this.$refs.mtbp_image.click()
    },
    /**
     * Handle file upload event so we can upload file
     * @param {Event} event - Event
     */
    handleFileUpload(event) {
      const file = event.target.files[0]

      if (!file) return

      const { name, size } = file
      const extFile = name.split('.').pop().toLowerCase()

      this.checkFileMetadata({
        extension: extFile,
        size,
        file,
      })
    },
    handleRemoveImage() {
      this.cleanupImagePreview()
      this.$refs.mtbp_image.value = ''
      this.image = null
      this.imagePreview = null
      this.imageError = null
    },
    /**
     * Automatically format price input
     */
    handlePriceInput(value) {
      if (this.priceInputTimeout) {
        clearTimeout(this.priceInputTimeout)
      }

      this.priceInputTimeout = setTimeout(() => {
        const numericValue = value.replace(/\D/g, '')

        const numberValue = parseInt(numericValue, 10) || 0
        this.price = numberValue

        this.priceFormatted = this.formatToIDR(numberValue)
      }, 150) // 150ms debounce
    },
    /**
     * Format price to IDR
     * @param {number} value - Price
     * @returns {string} - Formatted price
     */
    formatToIDR(value) {
      if (!value || value === 0) return ''

      return `Rp ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
    },
    /**
     * Validate numeric only
     * @param {Event} event - Event
     */
    validateNumericOnly(event) {
      const char = String.fromCharCode(event.keyCode || event.which)
      const numericRegex = /^[0-9]$/
      const controlKeys = /^(Backspace|Delete|Tab|Enter|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/

      if (!numericRegex.test(char) && !controlKeys.test(event.key)) {
        event.preventDefault()
      }
    },
    /**
     * Handle tambah bahan packing
     * note: submission_type is 1 = Add Mode
     */
    async handleTambahBahanPacking() {
      if (!this.image) {
        this.imageError = 'Gambar harus diisi'
        return
      }

      this.isPending = true

      let formData = new FormData()
      formData.append('image_file', this.image)
      formData.append('name', this.name)
      formData.append('price', this.price)
      formData.append('charge_type', this.satuan)
      formData.append('submission_type', 1) // 1 = Add Mode

      try {
        await this.$http_new.post('/komship/api/v1/packing-material-submissions', formData)
        this.isSuccess = true
      } catch (error) {
        toastError('Gagal menambahkan data, silahkan coba lagi')
      } finally {
        this.isPending = false
        formData = null
      }

      this.resetForm()
    },
    resetForm() {
      this.cleanupImagePreview()

      this.image = null
      this.imagePreview = null
      this.name = null
      this.price = null
      this.priceFormatted = ''
      this.satuan = 1
      this.imageError = null
      this.$refs.mtbp_image.value = ''
      this.$refs.observer.reset()
    },
  },
}
</script>

<style scoped>
#mtbp_form label {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 8px;
}
#mtbp_form label#mtbp_form_image {
    font-size: 16px;
    margin-bottom: 16px;
}

/* Custom Select Styling */
.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none !important;
  padding-right: 2.5rem !important;
}

.select-icon {
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6c757d;
  z-index: 2;
}

/* Hide default Bootstrap select arrow */
.custom-select::-ms-expand {
  display: none;
}
</style>
